module.exports = {"code":"SSO-200-017-001","messages":["NOT_A_VALID_EMAIL"],"status":false,"httpCode":"200","developerMessages":[]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/getEmail.json
// module id = 407
// module chunks = 0